<div
  class="lp-inventory-item-preview"
  style="width: 100%; height: 100%; display: grid; grid-template-rows: max-content 1fr; text-align: center"
>
  <div>
    <img [src]="icon()" style="width: 100%; aspect-ratio: 1; object-fit: contain" />
  </div>
  <h3 style="font-size: 0.8em; line-height: 1.1em; overflow: hidden; place-content: center">{{ name() }}</h3>
</div>
